<template>
  <CardComponent class="rcs-media">
    <i v-if="!isPreview" @click="$refs.uploadMenu.show()" class="fas fa-edit card-edit-btn absolute c-pointer"></i>
    <img v-if="isImage && mediaUrl" :src="mediaUrl" :alt="mediaAlt" />
    <video v-else-if="isVideo && mediaUrl" controls>
      <source :src="mediaUrl" :type="mediaType" />
      Your browser does not support the video tag.
    </video>
    <audio v-else-if="isAudio && mediaUrl" controls>
      <source :src="mediaUrl" :type="audioType" />
      Your browser does not support the audio tag.
    </audio>
    <div v-else-if="isPdf && mediaUrl" class="pdf-preview">
      <i class="fas fa-file-pdf pdf-icon"></i>
      <span class="pdf-name">{{ pdfName }}</span>
      <a :href="mediaUrl" target="_blank" class="pdf-link">Visualizar PDF</a>
    </div>
    <UploadComponent
      :preview="true"
      ref="uploadMenu"
      accept="image/jpeg,image/jpg,image/gif,image/png,video/h263,video/m4v,video/mp4,video/mpeg,video/mpeg4,video/webm,application/pdf,audio/aac,audio/mp3,audio/mpeg,audio/mpg,audio/mp4,audio/mp4-latm,audio/3gpp,application/ogg,audio/ogg"
      :maxFileSize="100"
      @uploaded="updateValue"
    />
  </CardComponent>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import UploadComponent from '@/components/ui/UploadComponent/Index.vue';

export default {
  name: 'RcsMedia',
  components: {
    CardComponent,
    UploadComponent,
  },
  props: {
    value: {
      type: [String, Object],
      default: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mediaUrl() {
      return typeof this.value === 'object' ? this.value.url || this.value.image : this.value;
    },
    mediaAlt() {
      return typeof this.value === 'object' ? this.value.title || 'Media content' : 'Media content';
    },
    mediaType() {
      const url = this.mediaUrl;
      if (url.endsWith('.mp4')) return 'video/mp4';
      if (url.endsWith('.webm')) return 'video/webm';
      if (url.endsWith('.ogg')) return 'video/ogg';
      if (url.endsWith('.mov')) return 'video/quicktime';
      if (url.endsWith('.mpeg')) return 'video/mpeg';
      if (url.endsWith('.m4v')) return 'video/mp4';
      return 'video/mp4'; // Default video type
    },
    audioType() {
      const url = this.mediaUrl;
      if (url.endsWith('.mp3')) return 'audio/mp3';
      if (url.endsWith('.aac')) return 'audio/aac';
      if (url.endsWith('.ogg')) return 'audio/ogg';
      if (url.endsWith('.mp4')) return 'audio/mp4';
      if (url.endsWith('.mpeg')) return 'audio/mpeg';
      if (url.endsWith('.3gpp')) return 'audio/3gpp';
      return 'audio/mp3'; // Default audio type
    },
    pdfName() {
      const url = this.mediaUrl;
      const fileName = url.split('/').pop();
      return fileName || 'Documento PDF';
    },
    isImage() {
      const url = this.mediaUrl;
      return url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.png') || url.endsWith('.gif') || url.endsWith('.webp') || url.endsWith('.svg') || url.endsWith('.bmp');
    },
    isVideo() {
      const url = this.mediaUrl;
      return (
        url.endsWith('.mp4') || url.endsWith('.webm') || url.endsWith('.ogg') || url.endsWith('.mov') || url.endsWith('.mpeg') || url.endsWith('.m4v') || url.endsWith('.h263')
      );
    },
    isAudio() {
      const url = this.mediaUrl;
      return (
        url.endsWith('.mp3') ||
        url.endsWith('.aac') ||
        url.endsWith('.mpeg') ||
        url.endsWith('.mpg') ||
        url.endsWith('.3gpp') ||
        (url.endsWith('.ogg') && !this.isVideo) ||
        (url.endsWith('.mp4') && url.includes('audio'))
      );
    },
    isPdf() {
      const url = this.mediaUrl;
      return url.endsWith('.pdf');
    },
  },
  methods: {
    updateValue(media) {
      this.$emit('input', media.data.path);
    },
  },
};
</script>

<style lang="scss" scoped>
.rcs-media {
  border-radius: 5px 20px 20px 20px;
  ::v-deep .card-body {
    padding: 0;
    border-radius: 20px;
    img,
    video,
    audio {
      border-radius: 20px;
      width: 100%;
    }
    .pdf-preview {
      padding: 20px;
      text-align: center;
      border-radius: 20px;
      background: #f8f9fa;

      .pdf-icon {
        font-size: 48px;
        color: #dc3545;
        margin-bottom: 10px;
      }

      .pdf-name {
        display: block;
        font-weight: bold;
        margin-bottom: 10px;
        color: #333;
      }

      .pdf-link {
        display: inline-block;
        padding: 8px 16px;
        background: #007bff;
        color: white;
        text-decoration: none;
        border-radius: 4px;
        transition: background 0.3s;

        &:hover {
          background: #0056b3;
          color: white;
          text-decoration: none;
        }
      }
    }
  }
}
.card-edit-btn {
  margin: 10px;
  color: #fff;
  cursor: pointer;
  left: 0;
  top: 0;
  z-index: 999;
}
.card-edit-btn i {
  color: #fff !important;
}
.card-edit-btn:hover {
  color: rgb(230, 230, 230);
}
</style>
